import React, {Component} from 'react'
import CTA from './CTA'
import Accordion from "../Accordion";

class Subjects extends Component {
    render() {
        return (
            <div id="subjectsIndex">
                <h1><i className="fas fa-atom" /> Subjects</h1>
                <p style={{color: '#5a5a5a'}}>We teach the following subjects. If you want to learn something that's not listed, feel free to <a href="/#contact">Contact Us</a> and we can refer you to our partners!</p>
                <hr/>
                <div id="subjectsRow">
                    <h1>MATH</h1>
                    <div className="subjectsAccordion">
                        <Accordion
                            body={
                            <div>
                                <ul>
                                    <li>SAT I and SAT II</li>
                                    <li>GMAT Math</li>
                                    <li>Pre-Algebra, Algebra I, Algebra II</li>
                                    <li>Geometry, Trigonometry</li>
                                    <li>Calculus I (AB), Calculus II (BC)</li>
                                    <li>Calculus III: Multivariable Calculus</li>
                                    <li>Calculus IV: Differential & Partial Differential Equations</li>
                                    <li>Linear Algebra</li>
                                    <li>Statistics</li>
                                </ul>
                            </div>}
                            size="medium"
                            header="See Details"
                        />
                    </div>
                </div>
                <hr/>
                <div id="subjectsRow">
                    <h1>CHEMISTRY</h1>
                    <div className="subjectsAccordion">
                        <Accordion
                            body={
                                <div>
                                    <ul>
                                        <li>High School Chemistry</li>
                                        <li>AP Chemistry</li>
                                        <li>Organic Chemistry I & II</li>
                                        <li>General Chemistry I & II</li>
                                        <li>Physical Chemistry</li>
                                    </ul>
                                </div>}
                            size="medium"
                            header="See Details"
                        />
                    </div>
                </div>
                <hr/>
                <div id="subjectsRow">
                    <h1>COMPUTER SCIENCE</h1>
                    <div className="subjectsAccordion">
                        <Accordion
                            body={
                                <div>
                                    <ul>
                                        <li>Intro to CS</li>
                                        <li>Python</li>
                                        <li>Full Stack Web Applications</li>
                                        <li>Algorithms & Data Structure</li>
                                        <li>Machine Learning</li>
                                        <li>Front-End (HTML, CSS, Javascript)</li>
                                        <li>Data Science</li>
                                        <li>SQL</li>
                                    </ul>
                                </div>}
                            size="medium"
                            header="See Details"
                        />
                    </div>
                </div>
                <hr/>
                <div id="subjectsRow">
                    <h1>BIOLOGY</h1>
                    <div className="subjectsAccordion">
                        <Accordion
                            body={
                                <div>
                                    <ul>
                                        <li>High School Biology</li>
                                        <li>AP Biology</li>
                                        <li>Biology I & II</li>
                                        <li>Biochemistry</li>
                                    </ul>
                                </div>}
                            size="medium"
                            header="See Details"
                        />
                    </div>
                </div>
                <hr/>
                <div id="subjectsRow">
                    <h1>HINDI</h1>
                    <div className="subjectsAccordion">
                        <Accordion
                            body={
                                <div>
                                    <ul>
                                        <li>Hindi Speaking</li>
                                        <li>Hindi Reading and Writing</li>
                                    </ul>
                                </div>}
                            size="medium"
                            header="See Details"
                        />
                    </div>
                </div>
                <br/><br/>
                <CTA content="Let us know where you need help "/>
            </div>
        )
    }
}

export default Subjects